(function() {
  const imageModules = $('.animateImageModule');
  const firstModule = $('.animateImageModule--zIndex').get(0);

  firstModule.style.position = 'static'

  imageModules.each(function(i) {
    const imageModule = $(this);
    const wrapper = $(this).find('.animateImageModule__imageWrapper');
    const image = $(this).find('.animateImageModule__image');
    const title = $(this).find('.animateImageModule__title');
    const description = $(this).find('.animateImageModule__description');

    $.jScrollability([
      {
        'selector': imageModule,
        'start': function($el) { return $el.offset().top + window.innerHeight },
        'end': function($el) { return $el.offset().top + $el.height() },
        'fn': function($el, pcnt) {
          wrapper.css({
            'width': `${((1 - pcnt) * 1.5) * window.innerWidth}px`,
            'height': `${((1 - pcnt) * 1.5) * window.innerHeight}px`,
          });

          if (pcnt > 0.33) {
            wrapper.addClass('animateImageModule__imageWrapper--active');
            if(window.innerWidth > 960) {
              image.css('transform', `translate(-50%, calc(-50% - ${Math.min((pcnt - 0.33) * 533, 160)}px)) scale(${Math.max(1 - pcnt + 0.33, 0.6)})`);
            } else {
              image.css('transform', `translate(-50%, calc(-50% - ${Math.min((pcnt - 0.33) * 266, 70)}px)) scale(${Math.max(Math.min(1 - (pcnt * 1.5) + 0.33, 0.75), 0.2)})`);
            }
          } else {
            wrapper.removeClass('animateImageModule__imageWrapper--active');
            if(window.innerWidth > 960) {
              image.css('transform', `translate(-50%, -50%) scale(1)`);
            } else {
              image.css('transform', `translate(-50%, -50%) scale(0.75)`);
            }
          }

          if (pcnt >= 0.75) {
            title.css({'opacity': `${((pcnt - 1) * 4) + 1}`,});
          } else {
            title.css({'opacity': '0',});
          }

          if (pcnt >= 0.8) {
            description.css({'opacity': `${((pcnt - 1) * 5) + 1}`,});
          } else {
            description.css({'opacity': '0',});
          }
        }
      }
    ]);
  });
}());
